'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _UserTimeline = require('../UserTimeline');

var _UserTimeline2 = _interopRequireDefault(_UserTimeline);

var _feedUserType = require('../../shared/feed-user-type');

var _feedUserType2 = _interopRequireDefault(_feedUserType);

var _propTypes = require('../../shared/prop-types');

var _loggingUtil = require('../../utils/logging-util');

var _communityContentContainers = require('../../shared/logging/community-content-containers');

var _communityContentContainers2 = _interopRequireDefault(_communityContentContainers);

var _logValues = require('../../shared/logging/log-values');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var HomeTimeline = function (_Component) {
  _inherits(HomeTimeline, _Component);

  function HomeTimeline(props) {
    _classCallCheck(this, HomeTimeline);

    var _this = _possibleConstructorReturn(this, (HomeTimeline.__proto__ || Object.getPrototypeOf(HomeTimeline)).call(this, props));

    _this.defaultLogData = _defineProperty({
      app: _logValues.WEB_APP,
      container: _communityContentContainers2.default.Home
    }, _logValues.ORIGIN_KEY, _logValues.FEED_ORIGIN);

    _this.state = {
      logData: _this.createLogData(_this.props)
    };
    return _this;
  }

  _createClass(HomeTimeline, [{
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      this.setState({
        logData: this.createLogData(this.state.logData, nextProps)
      });
    }
  }, {
    key: 'createLogData',
    value: function createLogData(currentLogData, newProps) {
      return (0, _loggingUtil.copyLogData)(currentLogData, newProps.logData, this.defaultLogData);
    }
  }, {
    key: 'render',
    value: function render() {
      var feedUserId = {
        relatedId: this.props.currentUserId || '-1',
        type: _feedUserType2.default.User
      };

      return _react2.default.createElement(_UserTimeline2.default, {
        endOfTimeline: this.props.endOfTimeline,
        feedUserId: feedUserId,
        logData: this.state.logData,
        store: this.props.store,
        waypointScrollableAncestor: this.props.waypointScrollableAncestor,
        miniProfileEnabled: true,
        isHomeTimeline: true,
        isSingleFeedPost: this.props.isSingleFeedPost,
        adTag: this.props.adTag });
    }
  }]);

  return HomeTimeline;
}(_react.Component);

HomeTimeline.propTypes = {
  currentUserId: _react.PropTypes.string,
  endOfTimeline: _react.PropTypes.element,
  logData: _react.PropTypes.object,
  store: _propTypes.StoreShape,
  waypointScrollableAncestor: _react.PropTypes.any,
  isSingleFeedPost: _react.PropTypes.bool,
  adTag: _propTypes.adTagShape
};
exports.default = HomeTimeline;